import { render, staticRenderFns } from "./Invoicedialog.vue?vue&type=template&id=23a4bb56&scoped=true&"
import script from "./Invoicedialog.vue?vue&type=script&lang=js&"
export * from "./Invoicedialog.vue?vue&type=script&lang=js&"
import style0 from "./Invoicedialog.vue?vue&type=style&index=0&id=23a4bb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4bb56",
  null
  
)

export default component.exports